<template>
  <div>
    <el-card>
      <div style="width:100%;height:200px;">
        <div style="line-height: 200px;text-align:center;">
            <div>
                <el-input v-model="sql" clearable placeholder="数据库执行语句" style="width:40%;"></el-input><el-button type="primary" @click="setSql">执行</el-button>
            </div>
        </div>
      </div>
      <el-table
        :data="tableData"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
        stripe
        style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="操作" width="100" align="center" :render-header="renderHeader">
          <template slot-scope="scope">
            <el-button type="text" @click="remove(scope.row,scope.$index)">删除</el-button>
            <el-button type="text" @click="update(scope.row,scope.$index)">刷新授权</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="数据库名"> </el-table-column>
        <el-table-column prop="url" align="center" label="数据库"></el-table-column>
        <el-table-column prop="root" align="center" label="账号"></el-table-column>
        <el-table-column prop="authorization" align="center" label="授权码"> </el-table-column>
        <el-table-column prop="time" align="center" sortable label="到期日期">
          <template slot-scope="scope">
            <span :style="(scope.row.date+86400)*1000>new Date().getTime()?'':'color: red;'">{{ scope.row.date | dateformat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      title="新增数据库"
      :visible.sync="dialogAdd"
      class="paramsDialog"
      :close-on-click-modal="false"
      width="30%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <div class="form_box">
          <el-form-item label="数据库名" prop="name">
            <el-input clearable style="width:275px;" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="数据库" prop="url">
            <el-input clearable style="width:275px;" v-model="ruleForm.url" placeholder="【主机地址】 : 【主机端口】 / 【数据库名】"></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="root">
            <el-input clearable style="width:275px;" v-model="ruleForm.root"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input clearable style="width:275px;" v-model="ruleForm.password"></el-input>
          </el-form-item>
          <el-form-item label="授权地址" prop="authorization">
            <el-input clearable style="width:275px;" v-model="ruleForm.authorization"></el-input>
          </el-form-item>
          <el-form-item label="到期日期" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              placeholder="选择到期日期"
              style="width:275px;">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="add">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="刷新授权"
      :visible.sync="dialogUpdate"
      class="paramsDialog"
      :close-on-click-modal="false"
      width="30%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm">
        <div class="form_box">
          <el-form-item label="到期日期" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              placeholder="选择到期日期"
              style="width:275px;">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="update2">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import httpApi from '@/http/api'
export default {
  name: "note",
  data() {
    return {
      tableData: [],
      idList: [],
      dialogAdd: false,
      dialogUpdate: false,
      sql: "",
      id: "",
      ruleForm: {
        name: "",
        url: "",
        root: "",
        password: "",
        authorization: "",
        date: "",
      },
      rules: {
        name: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        url: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        root: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        password: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        authorization: [{ required: true, message: "此项不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    init(){
        let that = this;
        httpApi
            .selSql()
            .then(res=>{
                if(res.data.code=="ok"){
                    that.tableData = res.data.data;
                }else{
                    that.$message.error(res.data.message);
                }
            })
    },
    renderHeader(h) {
        return(
            <div>
                <el-button type='text' onClick={()=>this.addDialog()}><i class='el-icon-circle-plus-outline' style='font-size:20px;'></i></el-button>
            </div>
        )
    },
    addDialog(){
      this.dialogAdd = true;
    },
    add(){
      let that = this;
      let time = undefined;
      if(that.ruleForm.date!=null&&that.ruleForm.date!=""){
        time = new Date(that.ruleForm.date).getTime() / 1000;
      }
      httpApi
        .addSql({
          params:{
            name: that.ruleForm.name,
            url: that.ruleForm.url,
            root: that.ruleForm.root,
            password: that.ruleForm.password,
            authorization: that.ruleForm.authorization,
            date: time
          }
        })
        .then(res=>{
            if(res.data.code=="ok"){
                that.init();
                that.dialogAdd = false;
            }else{
                that.$message.error(res.data.message);
            }
        })
    },
    remove(row,index){
      let that = this;
      httpApi
        .delSql({
          params:{
            id: row.id,
          }
        })
        .then(res=>{
            if(res.data.code=="ok"){
                that.$message.success(res.data.message);
                that.init();
            }else{
                that.$message.error(res.data.message);
            }
        })
    },
    update(row,index){
      let that = this;
      that.id=row.id;
      that.dialogUpdate = true;
    },
    update2(){
      let that = this;
      let time = null;
      if(that.ruleForm.date!=null){
        time = new Date(that.ruleForm.date).getTime() / 1000;
      }
      httpApi
        .updateSql({
          params:{
            id: that.id,
            date: time
          }
        })
        .then(res=>{
            if(res.data.code=="ok"){
                that.init();
                that.dialogUpdate = false;
            }else{
                that.$message.error(res.data.message);
            }
        })
    },
    //点击行选中
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //选择
    handleSelectionChange(val) {
      this.idList = val.map(i => i.id);
    },
    setSql(){
      let that = this;
      httpApi
        .setSql({
          params:{
            id: that.idList.join(),
            sql: that.sql,
          }
        })
        .then(res=>{
            if(res.data.code=="ok"){
                that.init();
                that.$message.success(res.data.message);
            }else{
                that.$message.error(res.data.message);
            }
        })
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
</style>